<div class="login-wrapper">
  <!-- Wavy Header -->
  <div class="header-section">
    <div class="header-content">
      <div class="header-icon-container">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="wfm-icon">
          <path d="M12.378 1.602a.75.75 0 0 0-.756 0L3 6.632l9 5.25 9-5.25-8.622-5.03ZM21.75 7.93l-9 5.25v9l8.628-5.032a.75.75 0 0 0 .372-.648V7.93ZM11.25 22.18v-9l-9-5.25v8.32a.75.75 0 0 0 .372.648l8.628 5.03Z" />
        </svg>
      </div>
      <h1 class="system-title">Workforce Management</h1>
      <p class="system-subtitle">Employee Roster Access</p>
    </div>
    
    <!-- Wave shape -->
    <div class="wave-container">
      <svg class="editorial" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28" preserveAspectRatio="none">
        <defs>
          <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
        </defs>
        <g class="parallax">
          <use xlink:href="#gentle-wave" x="50" y="0" fill="rgba(255,255,255,0.3)" />
          <use xlink:href="#gentle-wave" x="75" y="3" fill="rgba(255,255,255,0.5)" />
          <use xlink:href="#gentle-wave" x="90" y="5" fill="#f8fafc" />
        </g>
      </svg>
    </div>
  </div>

  <!-- Main Login Card Area -->
  <div class="login-card-container">
    <!-- User Avatar -->
    <div class="avatar-container">
      <div class="avatar">
        <!-- SVG Avatar representing a user -->
        <svg viewBox="0 0 100 100" class="avatar-svg">
          <circle cx="50" cy="38" r="18" fill="#e2e8f0" />
          <path d="M50 62c-20 0-32 10-32 20v4h64v-4c0-10-12-20-32-20z" fill="#cbd5e1" />
        </svg>
      </div>
    </div>

    <div class="welcome-text">
      <h2>Hello!</h2>
      <p>Enter your Employee ID to view your roster</p>
    </div>

    <form [formGroup]="loginForm" (ngSubmit)="proceedLogin()" class="form-card">
      <div class="input-section">
        <label class="field-label">Employee ID</label>
        <div class="input-wrapper" [class.error]="loginForm.get('employee_id')?.invalid && loginForm.get('employee_id')?.touched">
          <mat-icon class="input-icon">person_outline</mat-icon>
          <input 
            type="text" 
            placeholder="Enter your Employee ID" 
            formControlName="employee_id" 
            class="styled-input"
            autocomplete="off"
          />
          <button 
            *ngIf="loginForm.get('employee_id')?.value" 
            type="button" 
            class="clear-btn" 
            (click)="loginForm.get('employee_id')?.setValue('')"
          >
            <mat-icon>cancel</mat-icon>
          </button>
        </div>
        <div class="error-text" *ngIf="loginForm.get('employee_id')?.invalid && loginForm.get('employee_id')?.touched">
          Employee ID is required to login.
        </div>
        <div class="error-text token-error" *ngIf="errorMessage">
          {{ errorMessage }}
        </div>
      </div>

      <button type="submit" class="submit-btn" [disabled]="loginForm.invalid">
        <span>Login</span>
        <mat-icon class="btn-icon">arrow_forward</mat-icon>
      </button>
    </form>
  </div>
</div>